import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from '../common/loader';
import '../../common/css/noticeList.css';
import { useNavigate } from 'react-router-dom';

function FAQ() {
    const [NoticeStatue, setNoticeStatue] = useState('');
    const [isOn, setIsOn] = useState([]);
    const [FAQList, setFAQList] = useState([]);
    const [searchData, setSearchData] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [isWait, setIsWait] = useState(false);

    const navigate = useNavigate();

    const checkNoticeStatus = () => {
        const status = window.location.search.split('=')[1];

        if (status === 'all') {
            setNoticeStatue(status);
        } else if (status === 'fare') {
            setNoticeStatue(status);
        } else if (status === 'rule') {
            setNoticeStatue(status);
        } else if (status === 'reissue') {
            setNoticeStatue(status);
        }
    };

    const pagnation = () => {
        let result = [];
        const totalPage = Math.ceil(FAQList.total / 10);
        const params = new URLSearchParams(window.location.search);
        const page = params.get('pageNumber') ?? 1;

        for (let index = 1; index <= totalPage; index++) {
            result.push(
                <li class={`${page == index ? 'on' : ''}`}>
                    <a
                        onClick={() => {
                            updateURL(index);
                        }}
                    >
                        {index}
                    </a>
                </li>,
            );
        }
        return result;
    };

    // 페이지 네이션 클래스를 위한 URL 업데이트
    const updateURL = (index) => {
        navigate(`?pageNumber=${index}&search=${searchData}`, { replace: true });
        searchDataResult(index);
    };

    // 검색 이벤트
    const searchDataResult = async (pagenumber) => {
        try {
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.get(
                `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/faq/${NoticeStatue}?pageNumber=${
                    pagenumber ?? 1
                }&search=${searchData}`,
            );

            setFAQList(response.data);
            setTotalPage(Math.ceil(response.data.total / 10));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // 이전 및 다음 버튼 클릭 이벤트
    const pagnationBtn = (type) => {
        const curPage = parseInt(document.querySelector('.on a').textContent);

        if (type == 'prev' && curPage > 1) {
            window.location.href = `${window.location.pathname}?pageNumber=${
                curPage - 1
            }&search=${searchData}`;
        } else if (type == 'next' && curPage < totalPage) {
            window.location.href = `${window.location.pathname}?pageNumber=${
                curPage + 1
            }&search=${searchData}`;
        } else {
            alert(`${type == 'prev' ? '첫번째 페이지 입니다.' : '마지막 페이지 입니다.'}`);
        }
    };

    const toggleItem = (index) => {
        setIsOn((prev) =>
            prev.includes(index) ? prev.filter((item) => item !== index) : [...prev, index],
        );
    };

    useEffect(() => {
        const faqData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const page = params.get('pageNumber') ?? 1;

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/faq/${NoticeStatue}?pageNumber=${page}`,
                );
                console.log(response.data);
                setFAQList(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (NoticeStatue) {
            faqData();
        }
    }, [NoticeStatue]);

    useEffect(() => {
        checkNoticeStatus();
    }, []);

    // 리스트 map 끝나는 순간
    useEffect(() => {
        if (FAQList?.list && FAQList.list.length > 0) {
            setIsWait(true);
        }
    }, [FAQList]);

    return (
        <>
            {!isWait && <Loader list={'true'} />}

            <div id='contents' className='notice-contents'>
                <div class='subp_h_wrap'>
                    <div class='subp_h_list'>
                        <div class='subp_h_home'></div>
                        <div>공지사항</div>
                        <div>FAQ</div>
                    </div>
                </div>
                <div class='page_hgroup'>
                    <h2 class='title'>FAQ</h2>
                </div>

                <div class='tab_type type1'>
                    <div class='title_wrap'>
                        <div class='search_wrap search_box'>
                            <input
                                type='text'
                                class='search'
                                placeholder='검색어를 입력하세요'
                                value={searchData}
                                onChange={(e) => setSearchData(e.target.value)}
                            />
                            <button
                                class='button'
                                onClick={() => {
                                    searchDataResult();
                                }}
                            />
                        </div>
                    </div>
                    <div class='tab_wrap'>
                        <ul>
                            <li class={NoticeStatue === 'all' ? 'on' : ''}>
                                <a href='/notice/faq?status=all'>전체</a>
                            </li>
                            <li class={NoticeStatue === 'fare' ? 'on' : ''}>
                                <a href='/notice/faq?status=fare'>FARE 적용</a>
                            </li>
                            <li class={NoticeStatue === 'rule' ? 'on' : ''}>
                                <a href='/notice/faq?status=rule'>FARE RULE</a>
                            </li>
                            <li class={NoticeStatue === 'reissue' ? 'on' : ''}>
                                <a href='/notice/faq?status=reissue'>REISSUE </a>
                            </li>
                        </ul>
                    </div>

                    <div class='con_wrap mt60'>
                        <div class='on'>
                            <div class='faq mb30'>
                                <ul>
                                    {FAQList?.list?.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() => toggleItem(index)}
                                            className={isOn.includes(index) ? 'on' : ''}
                                        >
                                            <a href='#self'>{item.postTitle}</a>
                                            <div className='answer'>
                                                <div className='ck-content'
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.content
                                                            .replaceAll(/&quot;/g, '"')
                                                            .replaceAll(/&amp;/g, '&')
                                                            .replaceAll(/&lt;/g, '<')
                                                            .replaceAll(/&gt;/g, '>')
                                                    }}
                                                ></div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <script type='text/javascript'>Newriver.UI.Faq();</script>

                            <div class='pagenation'>
                                <div class='pagenation_inner'>
                                    <a
                                        class={`prev_page`}
                                        onClick={() => {
                                            pagnationBtn('prev');
                                        }}
                                    >
                                        이전페이지
                                    </a>
                                    <ul>{pagnation()}</ul>
                                    <a
                                        class={`next_page`}
                                        onClick={() => {
                                            pagnationBtn('next');
                                        }}
                                    >
                                        다음페이지
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FAQ;
